// extracted by mini-css-extract-plugin
module.exports = {"customLinkButton":"CardDetails_customLinkButton__10zCF","listItemWrapper":"CardDetails_listItemWrapper__1A1gq"};